import AppointmentsHistory from './AppointmentsHistory.view';

export default AppointmentsHistory;
